import API from '@/api'
import UserAccessPermissionsDataResponse from './models/UserAccessPermissionsDataResponse'
const getUserAccessPermissionsData = async (): Promise<UserAccessPermissionsDataResponse> => {
  return await API.UserAccessDataRepository.getUserAccessPermissionsData()
}

export default getUserAccessPermissionsData
